module.exports = require("@angular/animations/browser");